<template>
    <record-choose-item
        v-bind:recordData="source"
        v-bind:itemFunc="chooseGroupRecordItem">
    </record-choose-item>
</template>

<script>
import RecordChooseItem from '../record/RecordChooseItem.vue'
export default {
    name: 'GroupChooseItem',
    components: { RecordChooseItem },
    props: {
        source: {
            type: Object,
            default () {
                return {}
            }
        }
    },
    methods: {
        chooseGroupRecordItem(data){
            var arr = []; 
            arr.push([data.id, data.groupId]);
            if(data.selected){
                this.$store.dispatch('group/addSelectedGroupList', arr);
            }else{
                this.$store.dispatch('group/removeSelectedGroupList', arr);
            }
        },
    }
}
</script>